import * as React from "react";
import type { SVGProps } from "react";
const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 2a1 1 0 0 1 1 1v1h6v2H5V4h6V3a1 1 0 0 1 1-1M4.92 7h14.16l-.083 1.077-.858 11.153A3 3 0 0 1 15.148 22H8.852a3 3 0 0 1-2.991-2.77l-.089-1.153a1 1 0 1 1 1.994-.154l.089 1.154a1 1 0 0 0 .997.923h6.296a1 1 0 0 0 .997-.923L16.92 9H7.08l.379 4.923a1 1 0 0 1-1.995.154l-.461-6zm10.16 3.586-.084.997-.5 6-.082.997-1.994-.166.083-.997.5-6 .083-.997zm-4.084.831-.083-.997-1.993.166.083.997.5 6 .083.997 1.993-.166-.083-.997z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgTrash;
